'use strict';

angular.module('study.ecrd.field.queries', [
    'ecrd.queries',
    'inetsys.modal',
    // 'app.entity.queries',
    // 'app.entity.service',
]);
